import { withTranslation } from 'react-i18next';

export default function withPGTranslation(component, ns) {
  return withTranslation(ns)(component);
}
